import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAlertify from 'vue-alertify'
import VueLocalStorage from 'vue-localstorage'
import Router from 'vue-router'
import VueCollapse from 'vue2-collapse'

// import CheckLogin from '@/middlewaves/checkLogin'

import Home from '@/components/Page/Home'
import NearestStore from '@/components/Page/NearestStore'
import PageNotFound from '@/components/Page/PageNotFound'
import LoginPage from '@/components/Page/LoginPage'
import Page from '@/components/Page/Page'
import ProductDetail from '@/components/Page/ProductDetail'
import ProductMarket from '@/components/Page/ProductMarket'

import UpdateProfile from '@/components/Profile/UpdateProfile'
// import SettingStore from '@/components/SettingStore'
import Profile from '@/components/Profile/Profile'
import ProfileStore from '@/components/Profile/ProfileStore'
import ProfileGarden from '@/components/Profile/ProfileGarden'

import ManageTracking from '@/components/Tracking/ManageTracking'
import ReportTracking from '@/components/Tracking/Report'
import ManageSerial from '@/components/Cultivation/ManageSerial'

import SearchCode from '@/components/Tracking/SearchCode'
import ManageBlock from '@/components/Cultivation/ManageBlock'
import ManagePeriod from '@/components/Cultivation/ManagePeriod'
import ManageSeason from '@/components/Cultivation/ManageSeason'
import ManageHistory from '@/components/Cultivation/ManageHistory'

import ManageSubUser from '@/components/SubUser/ManageSubUser'
import ManageSaleLog from '@/components/SaleLog/ManageSaleLog'
import ChangePassword from '@/components/Profile/ChangePassword'
import ForgotPassword from '@/components/Profile/ForgotPassword'
import ActiveNewPassword from '@/components/Profile/ActiveNewPassword'
import LandMarket from '@/components/Land/LandMarket'
import LandDetail from '@/components/Land/LandDetail'
// import ManageLand from '@/components/ManageLand'

import SaleMarket from '@/components/SaleMarket/SaleMarket'
import SaleMarketProduct from '@/components/SaleMarket/SaleMarketProduct'
import SaleMarketVarriant from '@/components/SaleMarket/SaleMarketVarriant'

import ManageGarden from '@/components/Cultivation/ManageGarden'
import SearchGarden from '@/components/Cultivation/SearchGarden'
import ManageSaleMarket from '@/components/SaleMarket/ManageSaleMarket'
import SaleAdMarketDetail from '@/components/SaleMarket/SaleAdMarketDetail'
import SaleMarketOrderList from '@/components/SaleMarket/SaleMarketOrderList'
import SaleMarketSellerOrders from '@/components/SaleMarket/SaleMarketSellerOrders'
import SaleMarkeCart from '@/components/SaleMarket/SaleMarkeCart'

import SaleMarketStore from '@/components/SaleMarket/SaleMarketStore'
import FavoriteStores from '@/components/SaleMarket/FavoriteStores'
import LandingPage from '@/components/Profile/LandingPage'

import SearchStore from '@/components/Store/SearchStore'
import ManageStore from '@/components/Store/ManageStore'

import FormStore from '@/components/forms/FormStore'
import FormGarden from '@/components/forms/FormGarden'
import FormWarehouse from '@/components/forms/FormWarehouse'

import BlogCategories from '@/components/Blog/BlogCategories'
import BlogPosts from '@/components/Blog/BlogPosts'
import BlogSinglePost from '@/components/Blog/BlogSinglePost'

import ManageGroup from '@/components/Group/ManageGroup'
import FormGroup from '@/components/Group/FormGroup'
import GroupMember from '@/components/Group/GroupMember'
import GroupProfile from '@/components/Group/GroupProfile'

import Invitation from '@/components/Page/Invitation'
import Quotes from '@/components/Page/Quotes'

import Purchase from '@/components/Purchase/Purchase'
import PurchaseDetail from '@/components/Purchase/PurchaseDetail'
import checkLogin from '../middlewaves/checkLogin'

import SurveyCertificates from '@/components/Survey/Certificates'
import SurveyQuestions from '@/components/Survey/Questions'

import FormQuote from '@/components/forms/FormQuote'

import Manufacturers from '@/components/Page/Manufacturers'

// import Warehouses from '@/components/Page/Warehouses'
import IntroduceWarehouse from '@/components/Page/IntroduceWarehouse'

// import ManageTransportVehicle from '@/components/TransportVehicle/ManageTransportVehicle'
// import ManageRoute from '@/components/TransportVehicle/ManageRoute'

// import FormTransportVehicle from '@/components/forms/FormTransportVehicle'
// import FormRoute from '@/components/forms/FormRoute'

import DeleteUserRequest from '@/components/Page/DeleteUserRequest'

const moment = require('moment')

Vue.use(VueLocalStorage)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(VueAlertify)
Vue.use(VueCollapse)
require('moment/locale/vi')
Vue.use(require('vue-moment'), { moment })

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: NearestStore
    },
    {
      path: '/quotes',
      name: 'Quotes',
      component: Quotes
    },
    {
      path: '/nguon',
      name: 'Manufacturers',
      component: Manufacturers
    },
    {
      path: '/user-remove-request',
      name: 'DeleteUserRequest',
      component: DeleteUserRequest
    },
    
    // {
    //   path: '/kho',
    //   name: 'Warehouses',
    //   component: Warehouses
    // },

    {
      path: '/gardens',
      name: 'Gardens',
      component: Home
    },
    {
      path: '/landing',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/register/:type?',
      name: 'RegisterPage',
      component: LandingPage
    },

    {
      path: '/stores',
      name: 'Stores',
      component: Home
    }, {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }, {
      path: '/update-profile',
      name: 'UpdateProfile',
      component: UpdateProfile,
      meta: {
        middleware: checkLogin
      }
    },

    {
      path: '/profile/:profileId',
      name: 'Profile',
      component: Profile
    }, {
      path: '/store-profile/:storeId',
      name: 'ProfileStore',
      component: ProfileStore
    }, {
      path: '/garden-profile/:gardenId',
      name: 'ProfileGarden',
      component: ProfileGarden
    }, {
      path: '/garden-search/:productId/:productName/:lat/:lng',
      name: 'SearchGarden',
      component: SearchGarden
    }, {
      path: '/garden-search/:productId/:productName/:lat/:lng/:km',
      name: 'SearchGardenKM',
      component: SearchGarden
    }, {
      path: '/search-store/:productId/:productName/:lat/:lng',
      name: 'SearchStore',
      component: SearchStore
    }, {
      path: '/search-store/:productId/:productName/:lat/:lng/:km',
      name: 'SearchStoreKM',
      component: SearchStore
    }, {
      path: '/tracking/dashboard',
      name: 'ManageTracking',
      component: ManageTracking,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/tracking/report',
      name: 'ReportTracking',
      component: ReportTracking,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/manage-garden/stamp',
      name: 'ManageSerial',
      component: ManageSerial,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/manage-block',
      name: 'ManageBlock',
      component: ManageBlock,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/manage-garden/:block_id?/period',
      name: 'ManagePeriod',
      component: ManagePeriod,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/manage-garden/:period_id?/season',
      name: 'ManageSeason',
      component: ManageSeason,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/manage-garden/season/:season_id/history',
      name: 'ManageHistory',
      component: ManageHistory,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/manage-garden/season/:season_id/harvest/:harvest_id',
      name: 'ViewHarvest',
      component: ManageHistory,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/s/:unique_code',
      name: 'SearchCode',
      component: SearchCode
    }, {
      path: '/product/:productId/:productName/',
      name: 'ProductDetail',
      component: ProductDetail
    }, {
      path: '/page/:slug/',
      name: 'Page',
      component: Page
    }, {
      path: '/sub-users',
      name: 'ManageSubUser',
      component: ManageSubUser,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/sale-logs/:userId',
      name: 'ManageSaleLog',
      component: ManageSaleLog
    }, {
      path: '/change-password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    }, {
      path: '/activePassword/:hash',
      name: 'ActiveNewPassword',
      component: ActiveNewPassword
    }, {
      path: '/find-land',
      name: 'LandMarket',
      component: LandMarket
    },
    {
      path: '/find-land/:slug/:id',
      name: 'LandDetail',
      component: LandDetail
    }, {
      path: '/market',
      name: 'Market',
      component: ProductMarket
    }, {
      path: '/market/:id',
      name: 'MarketDetail',
      component: ProductMarket
    }, {
      path: '/mystore',
      name: 'ManageStore',
      component: ManageStore,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/mygarden',
      name: 'ManageGarden',
      component: ManageGarden,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/mygarden/add',
      name: 'AddGarden',
      component: FormGarden,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/mygarden/edit/:id',
      name: 'EditGarden',
      component: FormGarden,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/quote/add',
      name: 'AddQuote',
      component: FormQuote,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/quote/view/:id',
      name: 'ViewQuote',
      component: FormQuote,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/mystore/add',
      name: 'AddStore',
      component: FormStore,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/them-kho',
      name: 'AddWarehouse',
      component: FormWarehouse,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/kho',
      name: 'IntroduceWarehouse',
      component: IntroduceWarehouse
    },
    {
      path: '/mystore/edit/:code',
      name: 'EditStore',
      component: FormStore,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/sale-market/manage',
      name: 'ManageSaleMarket',
      component: ManageSaleMarket,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/sale-market',
      name: 'SaleMarket',
      component: SaleMarket
    }, {
      path: '/sale-market/my-orders',
      name: 'SaleMarketOrderList',
      component: SaleMarketOrderList,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/sale-market/seller-orders',
      name: 'SaleMarketSellerOrders',
      component: SaleMarketSellerOrders
    }, {
      path: '/sale-market/store/:store_id/:product_id/:varriant_id',
      name: 'SaleMarketStoreWithVarriant',
      component: SaleMarketStore
    }, {
      path: '/sale-market/store/:store_id',
      name: 'SaleMarketStore',
      component: SaleMarketStore
    }, {
      path: '/sale-market/favorited-stores',
      name: 'FavoriteStores',
      component: FavoriteStores,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/sale-market/ad/:ad_id',
      name: 'SaleAdMarketDetail',
      component: SaleAdMarketDetail
    }, {
      path: '/sale-market/product/:product_id',
      name: 'SaleMarketProduct',
      component: SaleMarketProduct
    }, {
      path: '/sale-market/product/:product_id/varriant/:varriant_id/:varriant_name',
      name: 'SaleMarketVarriant',
      component: SaleMarketVarriant
    }, {
      path: '/sale-market/carts',
      name: 'SaleMarkeCart',
      component: SaleMarkeCart,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/blog-categories',
      name: 'BlogCategories',
      component: BlogCategories
    },
    {
      path: '/blog-posts',
      name: 'BlogPosts',
      component: BlogPosts
    },
    {
      path: '/blog-cat-posts/:cat_id/:cat_slug',
      name: 'BlogCatPosts',
      component: BlogPosts
    },
    {
      path: '/blog-user-posts/:user_id/:user_slug',
      name: 'BlogUserPosts',
      component: BlogPosts
    },
    {
      path: '/blog/:id/:slug',
      name: 'BlogSinglePost',
      component: BlogSinglePost
    },
    {
      path: '/blog-posts',
      name: 'AllPosts',
      component: BlogPosts
    },
    {
      path: '/my-groups',
      name: 'ManageGroup',
      component: ManageGroup,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/my-groups/add',
      name: 'AddGroup',
      component: FormGroup,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/my-groups/edit/:id',
      name: 'EditGroup',
      component: FormGroup,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/my-groups/member/:id',
      name: 'GroupMember',
      component: GroupMember,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/group-profile/:id',
      name: 'GroupProfile',
      component: GroupProfile
    }, ,

    {
      path: '/my-invitation',
      name: 'Invitation',
      component: Invitation,
      meta: {
        middleware: checkLogin
      }
    }, ,
    {
      path: '/list-purchases',
      name: 'ListPurchase',
      component: Purchase,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/list-purchases/:type',
      name: 'ListTypePurchase',
      component: Purchase,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/survey-certificates',
      name: 'SurveyCertificates',
      component: SurveyCertificates,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/survey-questions/:survey_certificate_id',
      name: 'SurveyQuestions',
      component: SurveyQuestions,
      meta: {
        middleware: checkLogin
      }
    }, ,

    {
      path: '/purchase/:id',
      name: 'PurchaseDetail',
      component: PurchaseDetail,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/login/phone/:referral_phone',
      name: 'LoginReferral',
      component: LoginPage
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    }

  ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  // console.log('from',from);
  if (from.name == 'Login') {
    if (window.REQUIRE_LOGIN_ROUTE_NAME) {
      console.log('window.REQUIRE_LOGIN_ROUTE_NAME', window.REQUIRE_LOGIN_ROUTE_NAME)
      window.REQUIRE_LOGIN_ROUTE_NAME = null
      console.log('ok, set null')
    }
  }
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware, to })
  }

  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js